import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTheme } from '../../context/ThemeContext';
import TextField from '../../components/formfields/TextField';
import { UserCircle, ChevronDown, ChevronUp } from 'lucide-react';

const noop = () => {};

const AdvisorReferralCard = ({ advisorData }) => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const [expanded, setExpanded] = useState(true);

  if (!advisorData) return null;

  const containerClassName = clsx(
    'rounded-lg border transition-all duration-200',
    {
      'bg-slate-800 border-slate-700': isDark,
      'bg-green-50 border-green-200': !isDark
    }
  );

  const headerClassName = clsx(
    'flex items-center justify-between p-4 cursor-pointer',
    {
      'hover:bg-slate-700': isDark,
      'hover:bg-green-100': !isDark
    }
  );

  const titleClassName = clsx(
    'text-lg font-medium flex items-center gap-2',
    {
      'text-slate-200': isDark,
      'text-gray-900': !isDark
    }
  );

  const iconClassName = clsx(
    'w-4 h-4',
    {
      'text-slate-400': isDark,
      'text-gray-500': !isDark
    }
  );

  const contentClassName = clsx(
    'px-4 py-2 pb-4 space-y-4',
    {
      'border-t border-slate-600': isDark && expanded,
      'bg-white border-t rounded-br-lg rounded-bl-lg border-green-200': !isDark && expanded
    }
  );

  return (
    <div className={containerClassName}>
      <div className={headerClassName} onClick={() => setExpanded(!expanded)}>
        <div className="flex items-center gap-1">
          <UserCircle className="h-4 w-4" />
          <h3 className={titleClassName}>Your Travel Advisor</h3>
        </div>
        {expanded ? (
          <ChevronUp className={iconClassName} />
        ) : (
          <ChevronDown className={iconClassName} />
        )}
      </div>

      {expanded && (
        <div className={contentClassName}>
          <div className="grid grid-cols-2 gap-4">
            <TextField
              id="advisor-name"
              label="Travel Advisor Name"
              value={advisorData.advisorName || ''}
              onChange={noop}
              disabled
            />
            <TextField
              id="advisor-email"
              label="Travel Advisor Email"
              value={advisorData.advisorEmail || ''}
              onChange={noop}
              disabled
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            {advisorData.agencyName && (
              <TextField
                id="advisor-agency"
                label="Travel Agency"
                value={advisorData.agencyName}
                onChange={noop}
                disabled
              />
            )}
            {advisorData.consortiumName && (
              <TextField
                id="advisor-consortium"
                label="Consortium"
                value={advisorData.consortiumName}
                onChange={noop}
                disabled
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

AdvisorReferralCard.propTypes = {
  advisorData: PropTypes.shape({
    advisorName: PropTypes.string,
    advisorEmail: PropTypes.string,
    agencyName: PropTypes.string,
    consortiumName: PropTypes.string,
    displayId: PropTypes.string,
    travelAdvisorId: PropTypes.string
  })
};

export default AdvisorReferralCard;
